// AutoRenewDisclosure — Feb 28 2026 v6 (Randy pt-billing-compliance)
//
// Reusable auto-renewal disclosure block. Meets:
//   • California SB-313 / ROSCA (conspicuous disclosure)
//   • EU Consumer Rights Directive (clear cancel instructions)
//   • Better Business Bureau best-practices (linked refund policy)
//
// Placed immediately above ANY paid-checkout button (Creator subscription,
// silo-fan subscription, DFY purchase — anywhere Stripe recurring billing
// starts). Deliberately plain-text and dense so it can't be mistaken for
// marketing copy. Do NOT decorate with icons.
//
// Props:
//   • priceLabel — e.g. "$15/month" (must include unit). MUST be built from
//     a LIVE price (usePublicPricing / the SKU catalog). Never pass a literal:
//     a disclosure quoting a retired price is a compliance problem, and that is
//     exactly what happened here between Jul and Oct 2026.
//   • cadence — e.g. "monthly" (used in cancel-anytime line)
//   • dense (optional) — smaller text variant for tight modal footers
//   • className (optional) — pass-through for layout tweaks
import React from "react";
import { Link } from "react-router-dom";

export default function AutoRenewDisclosure({
  priceLabel,
  cadence = "monthly",
  dense = false,
  className = "",
}) {
  const cls = dense
    ? "text-[11px] leading-relaxed text-[#6B6A68]"
    : "text-xs leading-relaxed text-[#6B6A68]";
  return (
    <div className={`${cls} ${className}`} data-testid="auto-renew-disclosure">
      By subscribing you agree to be charged{" "}
      <strong className="text-[#1C1B1A]">{priceLabel}</strong> today, and{" "}
      the same amount every {cadence === "monthly" ? "month" : cadence}{" "}
      on this date until you cancel. Cancel anytime from{" "}
      <strong className="text-[#1C1B1A]">Account → Billing</strong> — no fees,
      no calls, no forms. See our{" "}
      <Link
        to="/refund-policy"
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-[#4A5D4E]"
        data-testid="auto-renew-refund-link"
      >
        Refund Policy
      </Link>
      {" · "}
      <Link
        to="/terms"
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-[#4A5D4E]"
      >
        Terms
      </Link>
      .
    </div>
  );
}
